import { upperCaseFirst } from './upperCaseFirst';
export function firstInitial(input) {
    return upperCaseFirst(input).slice(0, 1) + '.';
}
